<template>
  <div class="mx-10 ma-5">
    <v-card flat class="pa-5">
      <PageTitleWithSearch
        :title="'Manage GL Accounts'"
        :btnName="'Add New GL Account'"
        :btnColor="'#00B3FF'"
        :btnRoute="'/gl-account/create'"
        :btnPermission="'gl_account.create'"
        :btnEnable="true"
        :loading="loading"
        :search="filters.search"
        @searchText="searchChange"
      >
      </PageTitleWithSearch>
      <DataTableWithPagination
        :headers="headers"
        :items="accounts"
        :loading="loading"
        :page="page"
        :total="total"
        @pageChange="page = $event"
      >
        <template #row="{ item, index }">
          <tr
            :class="[
              { 'first-row': index === 0 },
              index % 2 === 0 ? 'dark-row' : 'light-row',
              'custom-row',
            ]"
          >
            <td class="text-left">{{ item.title }}</td>
            <td class="text-left">
              {{
                item.gl_account_type && item.gl_account_type.title
                  ? item.gl_account_type.title
                  : null
              }}
            </td>
            <td class="text-left">
              {{
                item.gl_sub_header && item.gl_sub_header.name
                  ? item.gl_sub_header.name
                  : null
              }}
            </td>
            <td class="text-left">{{ item.description }}</td>
            <td class="text-right">{{ item.balance }}</td>
            <td>
              <v-btn
                v-if="hasPermission('gl_account.edit')"
                class="ma-1"
                color="#FFE0B2"
                @click="editAccount(item)"
                fab
                x-small
                style="box-shadow: none;"
              >
                <v-icon small color="#FF9800"> mdi-pencil </v-icon>
              </v-btn>
              <v-btn
                v-else
                class="ma-1"
                disabled
                fab
                x-small
                style="box-shadow: none;"
                ><v-icon small color="#FF9800">mdi-pencil</v-icon></v-btn
              >
            </td>
          </tr>
        </template>
      </DataTableWithPagination>

      <!-- Edit Dialog -->
      <v-dialog v-model="editDialog" max-width="600px">
        <v-card>
          <v-card-title>Edit Account</v-card-title>
          <v-card-text>
            <v-form ref="editForm" v-model="valid">
              <v-text-field
                v-model="editedAccount.title"
                label="Account Name"
                required
                disabled
              ></v-text-field>
              <v-text-field
                v-model="editedAccount.description"
                label="Description"
                outlined
                dense
              ></v-text-field>
              <v-select
                v-model="editedAccount.gl_account_type_id"
                :items="accountTypes"
                item-text="title"
                item-value="id"
                label="Account Type"
                outlined
                dense
                disabled
              ></v-select>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn text @click="editDialog = false">Cancel</v-btn>
            <v-btn text @click="saveAccount" :disabled="!valid">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card>
  </div>
</template>

<script>
import DataTableWithPagination from "@/components/shared/DataTableWithPagination.vue";

import { GLAccountService } from "@/services/gl-account-service";
import PageTitleWithSearch from "@/components/shared/PageTitleWithSearch";
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("auth");

export default {
  components: { PageTitleWithSearch, DataTableWithPagination },
  data() {
    return {
      accounts: [],
      loading: false,
      filters: {
        search: "",
      },
      page: 1,
      total: 0,
      headers: [
        { text: "Account Name", value: "title" },
        { text: "Account Type", value: "gl_account_type.title" },
        { text: "Sub Header", value: "gl_sub_header.name" },
        { text: "Description", value: "description" },
        { text: "Balance", value: "balance" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      editDialog: false,
      editedAccount: {},
      accountTypes: [],
      valid: false,
    };
  },
  computed: {
    ...mapGetters({
      hasPermission: "hasPermission",
    }),
  },
  methods: {
    async fetchAccounts() {
      console.log(
        "Fetching accounts with filters:",
        this.filters,
        "and page:",
        this.page
      );
      this.loading = true;
      try {
        const response = await GLAccountService.list(
          {
            ...this.filters,
          },
          this.page
        );
        this.accounts = response.data?.data || [];
        this.total = response.data?.meta?.last_page || 0;
      } catch (error) {
        this.accounts = [];
        this.total = 0;
        console.error("Error fetching accounts:", error);
      } finally {
        this.loading = false;
      }
    },
    async editAccount(account) {
      this.editedAccount = { ...account };
      this.editDialog = true;
    },
    async saveAccount() {
      try {
        await GLAccountService.update(
          this.editedAccount.id,
          this.editedAccount
        );
        this.editDialog = false;
        this.fetchAccounts();
      } catch (error) {
        console.error("Error updating account:", error);
      }
    },
    searchChange(value) {
      this.filters.search = value;
      this.page = 1;
      this.fetchAccounts();
    },
    async fetchAccountTypes() {
      try {
        const response = await GLAccountService.getAccountTypes();
        this.accountTypes = response.data;
      } catch (error) {
        console.error("Error fetching account types:", error);
      }
    },
  },
  watch: {
    page() {
      this.fetchAccounts();
    },
  },
  mounted() {
    this.fetchAccounts();
    this.fetchAccountTypes();
  },
};
</script>
